<template>
  <v-dialog v-model="visible" max-width="100%" persistent scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <p>
              ¿Desea reportar el programa
              <strong>{{ form.nombreCompuesto }}</strong>
              con código <strong>{{ form.codigo }}</strong> de la sede <strong>{{ form.sede?.nombre }}</strong>
              que actualmente se encuentra en el módulo
              <strong>{{ programaModuloTexto }}</strong>
              vinculado al programa de universidad
              <strong>{{ form.programaUniversidad?.programaNombre || '-' }}</strong>
              de código
              <strong>{{ form.programaUniversidad?.codigo || '-' }}</strong>
              de la universidad <strong>{{ form.universidad?.nombre }}</strong>
              ?
            </p>

            <p>
              Usted será responsable de reportar programas que no cumplan con los requisitos establecidos por la
              universidad. Asegúrese de verificar toda la información antes de proceder con el reporte.
            </p>

            <p>UNA VEZ REPORTADO, <strong>NO SE PODRÁN REALIZAR MÁS INSCRIPCIONES O DESINSCRIPCIONES.</strong></p>
          </v-col>

          <v-col cols="12">
            <TablaInscripcionesProgramaUniversidad
              :inscripciones-programa-universidad-cumplen-requisitos="inscripcionesProgramaUniversidadCumplenRequisitos"
              :inscripciones-programa-universidad-no-cumplen-requisitos="
                inscripcionesProgramaUniversidadNoCumplenRequisitos
              " />

            <TablaInscripcionesPrograma
              :inscripciones-programa-cumplen-requisitos-no-inscritos-en-programa-universidad="
                inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad
              " />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="red darken-1" text @click.prevent="reportar"> Reportar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import inscripcionService from '../services/inscripcion.service';
import programaService from '../services/programa.service';
import programasReportadosService from '../services/programas-reportados.service';
import { ESTADOS_ACADEMICOS, ESTADOS_ADMINISTRATIVOS, ESTADOS_CARTERA, ESTADOS_INSCRIPCION } from '../utils/constantes';
import { imprimirModulo, obtenerModuloMasAlto } from '../utils/funciones';
import TablaInscripcionesProgramaUniversidad from './TablaInscripcionesProgramaUniversidad.vue';
import TablaInscripcionesPrograma from './TablaInscripcionesPrograma.vue';

export default {
  name: 'ModalReportarPrograma',
  components: {
    TablaInscripcionesProgramaUniversidad,
    TablaInscripcionesPrograma,
  },
  created() {
    this.$store.dispatch('pago/setFiltrarPorSede', true);
  },
  data() {
    return {
      titulo: 'Reportar Programa',
      form: this.generarObjetoFormRegistrar(),
      visible: false,
      reportando: false,
      inscripcionesPrograma: [],
      inscripcionesProgramaUniversidad: [],
      estadosInscripcion: ESTADOS_INSCRIPCION,
    };
  },
  computed: {
    ...mapGetters({
      permisosAcademicosSede: 'pago/permisosAcademicosSede',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
      getFiltrarPorSede: 'pago/getFiltrarPorSede',
    }),
    programaModuloMasAlto() {
      const programasModulos = this.form?.programasModulos;

      return obtenerModuloMasAlto(programasModulos);
    },
    programaModuloTexto() {
      return imprimirModulo(this.programaModuloMasAlto);
    },
    inscripcionesProgramaUniversidadCumplenRequisitos() {
      return this.inscripcionesProgramaUniversidad.filter((inscripcionProgramaUniversidad) => {
        const estadoCarteraNombre = inscripcionProgramaUniversidad.inscripcion.estadoCartera?.nombre;
        const estadoAdministrativoNombre = inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo?.nombre;
        const estadoAcademicoNombre = inscripcionProgramaUniversidad.inscripcion.estadoAcademico?.nombre;

        return (
          inscripcionProgramaUniversidad.inscripcion.estadoInscripcion == 1 &&
          [ESTADOS_CARTERA['Exento de deuda'], ESTADOS_CARTERA['Vigente']].includes(estadoCarteraNombre) &&
          estadoAdministrativoNombre === ESTADOS_ADMINISTRATIVOS['Inscrito'] &&
          [
            ESTADOS_ACADEMICOS['En Desarrollo'],
            ESTADOS_ACADEMICOS['En Desarrollo - Nivelacion'],
            ESTADOS_ACADEMICOS['Concluido Aprobado'],
          ].includes(estadoAcademicoNombre)
        );
      });
    },
    inscripcionesProgramaUniversidadNoCumplenRequisitos() {
      return this.inscripcionesProgramaUniversidad.filter(
        (inscripcion) =>
          this.inscripcionesProgramaUniversidadCumplenRequisitos.findIndex(
            (inscripcionCumple) => inscripcionCumple.id === inscripcion.id,
          ) === -1,
      );
    },
    inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad() {
      return this.inscripcionesPrograma
        .filter((inscripcionPrograma) => {
          return inscripcionPrograma.programaId === this.form.id;
        })
        .filter((inscripcionPrograma) => {
          const estadoCarteraNombre = inscripcionPrograma.estadoCartera?.nombre;
          const estadoAdministrativoNombre = inscripcionPrograma.estadoAdministrativo?.nombre;
          const estadoAcademicoNombre = inscripcionPrograma.estadoAcademico;
          const cumpleRequisitos =
            inscripcionPrograma.estadoInscripcion === 1 &&
            [ESTADOS_CARTERA['Exento de deuda'], ESTADOS_CARTERA['Vigente']].includes(estadoCarteraNombre) &&
            estadoAdministrativoNombre === ESTADOS_ADMINISTRATIVOS['Inscrito'] &&
            [
              ESTADOS_ACADEMICOS['En Desarrollo'],
              ESTADOS_ACADEMICOS['En Desarrollo - Nivelacion'],
              ESTADOS_ACADEMICOS['Concluido Aprobado'],
            ].includes(estadoAcademicoNombre);

          const estaInscritoEnProgramaUniversidad = this.inscripcionesProgramaUniversidad.some(
            (inscripcionPU) => inscripcionPU.inscripcion.id == inscripcionPrograma.id,
          );

          return cumpleRequisitos && !estaInscritoEnProgramaUniversidad;
        });
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        sedeId: null,
        sede: null,
        gestion: null,
        nombreCompuesto: null,
        postgradoId: null,
        postgrado: null,
        programaUniversidadId: null,
        programaUniversidad: null,
        nombreCorto: null,
        version: null,
        grupo: null,
        universidadId: null,
        universidad: null,
        programasModulos: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        sedeId: data.sedeId,
        sede: data.sede,
        gestion: data.gestion,
        nombreCompuesto: data.nombreCompuesto,
        postgradoId: data.postgradoId,
        postgrado: data.postgrado,
        programaUniversidadId: data.programaUniversidadId,
        programaUniversidad: data.programaUniversidad,
        nombreCorto: data.nombreCorto,
        version: data.version,
        grupo: data.grupo,
        universidadId: data.universidadId,
        universidad: data.universidad,
        programasModulos: data.programasModulos || [],
      };
    },
    abrir(accion, data = []) {
      this.form = this.generarObjetoFormEditar(data);

      Promise.all([this.obtenerInscritosEnPrograma(), this.obtenerInscritosEnProgramaUniversidad()]).then(() => {
        this.visible = true;
      });
    },
    cerrar() {
      this.visible = false;
    },
    async reportar() {
      if (this.inscripcionesProgramaUniversidad.length === 0) {
        this.$notify({
          group: 'notifications',
          title: 'Advertencia',
          text: 'No se puede reportar el programa porque no tiene inscripciones activas.',
          type: 'error',
        });

        return;
      }

      this.reportando = true;

      try {
        const dataEnviar = {
          programaId: this.form.id,
          programaUniversidadId: this.form.programaUniversidadId,
          inscripcionesReportadas: [
            ...this.inscripcionesProgramaUniversidadCumplenRequisitos.map((inscripcionProgramaUniversidad) => ({
              inscripcionId: inscripcionProgramaUniversidad.inscripcion.id,
              inscripcionProgramaUniversidadId: inscripcionProgramaUniversidad.id,
              cumpleRequisitos: true,
              estadoInscripcion: inscripcionProgramaUniversidad.inscripcion.estadoInscripcion,
              estadoCartera: inscripcionProgramaUniversidad.inscripcion.estadoCartera?.nombre || null,
              estadoAdministrativo: inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo?.nombre || null,
              estadoAcademico: inscripcionProgramaUniversidad.inscripcion.estadoAcademico?.nombre || null,
            })),
            ...this.inscripcionesProgramaUniversidadNoCumplenRequisitos.map((inscripcionProgramaUniversidad) => ({
              inscripcionId: inscripcionProgramaUniversidad.inscripcion.id,
              inscripcionProgramaUniversidadId: inscripcionProgramaUniversidad.id,
              cumpleRequisitos: false,
              estadoInscripcion: inscripcionProgramaUniversidad.inscripcion.estadoInscripcion,
              estadoCartera: inscripcionProgramaUniversidad.inscripcion.estadoCartera?.nombre || null,
              estadoAdministrativo: inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo?.nombre || null,
              estadoAcademico: inscripcionProgramaUniversidad.inscripcion.estadoAcademico?.nombre || null,
            })),
            ...this.inscripcionesProgramaCumplenRequisitosNoInscritosEnProgramaUniversidad.map(
              (inscripcionPrograma) => ({
                inscripcionId: inscripcionPrograma.id,
                inscripcionProgramaUniversidadId: null,
                cumpleRequisitos: true,
                estadoInscripcion: inscripcionPrograma.estadoInscripcion,
                estadoCartera: inscripcionPrograma.estadoCartera?.nombre || null,
                estadoAdministrativo: inscripcionPrograma.estadoAdministrativo?.nombre || null,
                estadoAcademico: inscripcionPrograma.estadoAcademico?.nombre || null,
              }),
            ),
          ],
        };

        await programasReportadosService.create(dataEnviar);

        this.$emit('programa-reportado');

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'El programa ha sido reportado exitosamente.',
          type: 'success',
        });
        this.cerrar();
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al reportar el programa. Por favor, inténtelo de nuevo.',
          type: 'error',
        });
      } finally {
        this.reportando = false;
      }
    },
    async obtenerInscritosEnPrograma() {
      this.inscripcionesPrograma = [];

      try {
        const params = {
          programaUniversidadId: this.form.programaUniversidadId,
          sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
        };

        const response = await inscripcionService.findAllPorProgramaUniversidadVerificacion({ params });
        const data = response?.data;

        this.inscripcionesPrograma = data?.datos || [];
        this.$notify({
          group: 'notifications',
          title: 'Información',
          text: `El programa tiene ${this.inscripcionesPrograma.length} inscripciones activas.`,
          type: 'info',
        });
      } catch (error) {
        window.console.log({ error });

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al obtener las inscripciones del programa. Por favor, inténtelo de nuevo.',
          type: 'error',
        });
      }
    },
    async obtenerInscritosEnProgramaUniversidad() {
      this.inscripcionesProgramaUniversidad = [];

      try {
        const response = await programaService.findAllInscripcionesProgramaUniversidad(this.form.id);
        const data = response?.data;

        this.inscripcionesProgramaUniversidad = data?.datos || [];
        this.$notify({
          group: 'notifications',
          title: 'Información',
          text: `El programa de universidad tiene ${this.inscripcionesProgramaUniversidad.length} inscripciones activas.`,
          type: 'info',
        });
      } catch (error) {
        window.console.log({ error });

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al obtener las inscripciones del programa de universidad. Por favor, inténtelo de nuevo.',
          type: 'error',
        });
      }
    },
  },
};
</script>